import React, { Component } from 'react';
import { Input } from '@vds/inputs';
import { Button } from '@vds/buttons';
import { Micro, Body } from '@vds/typography';
import { ENABLE_OMNI_CART, GOOGLE_RECAPTCHA_SITEKEY, REDIRECT_4G_URL, REDIRECT_5G_URL } from './../../../containers/constants';
import { disableCheckAvailblityButton, enableCheckAvailblityButton, resetCheckoutFlags, setCheckAvailabilityClicked, redirectionHandler, redirectLBOPage } from '../containers/action';
import { connect } from 'react-redux';
import * as  SiteCatalyst from "../../../sitecatalyst";
import '../CheckAvailability/CheckAvailability.css';
import { scrollForLQInputErrors, isNightTimeWindow } from '../../../utils/common';
import apiClient from '../../../utils/apiClient';
import { CHECK_VZW_URL, FTR_FIOS_URL} from '../../../containers/APIurls';
import debounce  from 'lodash/debounce';
import SpinnerComponent from '../../../Common/Spinner/Spinner';
import ReCAPTCHA from "react-google-recaptcha";
import { CheckAEMBoolValue } from '../../../Common/CommonPlanTile/CommonPlanTile';
import { Modal,ModalBody } from '@vds3/modals';
import { Body as VDS3Body} from '@vds3/typography';
import { Button as VDS3Button, TextLink} from '@vds3/buttons';
import { triggerFTRMatrix } from '../../CustomizeOrder/ContractAgreement/containers/action';
import * as SiteAnalyticsOmni from '../../../sitecatalyst/omniDl';
const recaptchaRef = React.createRef();
class CheckAvailability extends Component {
    constructor(props) {
        super(props);
        this.state = {
            enableErrorMessageForPhoneNumber: false,
            errorMessageForPhoneNumber: "Your mobile number must be 10 digits.",
            enableErrorMessageForEmailAddress: false,
            errorMessageForEmailAddress: "Please enter your valid email address.",
            enableSpinner: false,
            recaptchaValue: '',
            disableCheckAvailability:true,
            Cflag:false,
            showFTRDay1Modal:false
            // chkAvailibtyClicked:false
        }
        window.addEventListener('recievedDoLoopResponse', this.triggerAddressQualification);
        if (ENABLE_OMNI_CART === "true") {
            window.addEventListener('recievedOptixAddressQualificationResponse', this.triggerAddressQualification);
        }
        this.debouncedPhoneFn = debounce((input) => {
            this.props.postUIEventLog({ eventType: 'log', eventName: "PhoneNumber Input", sectionName: "LQ", log: input });
        }, 2000);
        this.debouncedEmailFn = debounce((input) => {
            this.props.postUIEventLog({ eventType: 'log', eventName: "Email Input", sectionName: "LQ", log: input });
        }, 2000);
    }

    componentWillUnmount() {
        window.removeEventListener('recievedDoLoopResponse', this.triggerAddressQualification);
        if (ENABLE_OMNI_CART === "true") {
            window.removeEventListener('recievedOptixAddressQualificationResponse', this.triggerAddressQualification);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.phoneNumber && !nextProps.emailAddress) {
            this.setState({
                enableErrorMessageForPhoneNumber: false,
                enableErrorMessageForEmailAddress: false
            });
        }
    }

    validatePhoneNumber = (phoneNumber) => {
        return (/^\d{10}$/.test(phoneNumber));
    };

    savePhoneNumber = (e) => {
        const value = e.target.value;
        const phoneNumber = value?.replace(/[^0-9]+/g, "");

        this.setState({ enableErrorMessageForPhoneNumber: false });
        if(phoneNumber === ''){
            this.setState({
                enableErrorMessageForPhoneNumber: true
            });
            this.setState({disableCheckAvailability:true}) 
            this.props.savePhoneNumber(''); 
            recaptchaRef.current.reset();
             this.setState({recaptchaValue: ''})      
            return false;
        }

        if (/^[0-9]{0,10}$/.test(phoneNumber)) {
            const formattedPhoneNumber = phoneNumber?.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
            this.props.savePhoneNumber(formattedPhoneNumber);
            if (phoneNumber && !this.validatePhoneNumber(phoneNumber)) {
                this.setState({ enableErrorMessageForPhoneNumber: true });
            }
            this.debouncedPhoneFn(phoneNumber);
        }
        this.props.resetCheckoutFlags();
    }

    saveEmailAddress = (e) => {
        const emailAddress = e.target.value.replace(/[^\w\s?:.@-]/gi, "")

        this.setState({
            enableErrorMessageForEmailAddress: false
        });
        if(emailAddress === ''){
            this.setState({
                enableErrorMessageForEmailAddress: true
            });
            this.setState({disableCheckAvailability:true})
            this.props.saveEmailAddress('')
            recaptchaRef.current.reset();
            this.setState({recaptchaValue: ''})
            return false;
        }else{
            const pattern = /^[\w-'_\.a-zA-Z]+@+[\w-_\.a-zA-Z]*[\w-_\.a-zA-Z]+\.((com|COM|net|NET|org|ORG|edu|EDU|mil|MIL|name|NAME|[a-z A-Z]{2})$)|(((com|COM|net|NET|org|ORG|edu|EDU|mil|MIL|name|NAME)\.[a-z A-Z]{2})$)/;
            const isValidEmail = pattern.test(emailAddress)
            this.setState({ enableErrorMessageForEmailAddress: !isValidEmail });
        }
        this.debouncedEmailFn(emailAddress);
        this.props.saveEmailAddress(emailAddress);
    }

    isValidPhoneNumber = () => {
        const phoneNumber = this.props.phoneNumber?.replace(/-/g, "");
        if (!phoneNumber || !this.validatePhoneNumber(phoneNumber)) {
            this.setState({
                enableErrorMessageForPhoneNumber: true
            });
            return false;
        } else if (this.validatePhoneNumber(phoneNumber)) {

            if (phoneNumber != null) {
                if (phoneNumber.charAt(0) == '0' || phoneNumber.charAt(0) == '1' || phoneNumber == "2222222222" || phoneNumber == "3333333333" || phoneNumber == "4444444444" || phoneNumber == "5555555555" || phoneNumber == "6666666666" || phoneNumber == "7777777777" || phoneNumber == "8888888888" || phoneNumber == "9999999999" || phoneNumber == "4465445654") {
                    this.setState({
                        enableErrorMessageForPhoneNumber: true,
                        errorMessageForPhoneNumber: "Please enter your valid phone number."
                    });
                    return false;
                }
            }
            return true;
        }
        return false;
    }

    isValidEmail = () => {
        const emailAddress = this.props.emailAddress;
        if (emailAddress) {
            const filter = /^[\w-'_\.a-zA-Z]+@+[\w-_\.a-zA-Z]*[\w-_\.a-zA-Z]+\.((com|COM|net|NET|org|ORG|edu|EDU|mil|MIL|name|NAME|[a-z A-Z]{2})$)|(((com|COM|net|NET|org|ORG|edu|EDU|mil|MIL|name|NAME)\.[a-z A-Z]{2})$)/;

            if (!filter.test(emailAddress?.trim())) {
                this.setState({
                    enableErrorMessageForEmailAddress: true
                });
                return false;
            }
            this.props.saveEmailAddress(emailAddress?.trim());
        } else if (!emailAddress) { 
            this.setState({
                enableErrorMessageForEmailAddress: true
            });
            return false;
        }
        return true;
    }

    handleSubmit = (e) => {
        e.preventDefault()
    }

    isValidDetailsSubmitted = () => {
        const addressValidated = this.props.validateAddress();
        const phoneNumberValidated = this.isValidPhoneNumber();
        const emailValidated = this.isValidEmail();
        const unitValidated = this.props.validateUnits();

        // if (window.screen.width <= 450) {
        if (addressValidated) {
            if (unitValidated) {
                if (phoneNumberValidated) {
                    if (emailValidated) {

                    } else {
                        scrollForLQInputErrors(".Email-Input");
                    }
                } else {
                    scrollForLQInputErrors('.Phone-Input-box');
                }
            } else {
                scrollForLQInputErrors('.Unit-inputbox');
            }
        } else {
            scrollForLQInputErrors('.Street-Address');
        }
        //}

        return (addressValidated && phoneNumberValidated && emailValidated && unitValidated);
    }
    ftrDay1Modal = () => {
    let ftrDay1header1 = (this.props.t && typeof this.props.t == 'function') ? this.props.t("fios.ftrDay1header1",{ns:"fios"}) : "Great news!";
    let ftrDay1header2 = (this.props.t && typeof this.props.t == 'function') ? this.props.t("fios.ftrDay1header2",{ns:"fios"}) : " Frontier Business Internet is available at your address.";
    let ftrDay1Content = (this.props.t && typeof this.props.t == 'function') ? this.props.t("fios.ftrDay1Content",{ns:"fios"}) : "Frontier Business Fiber Internet is now powered by Verizon! Order at business.frontier.com to save $20 as a Verizon Mobile and Fiber internet customer.";

        return (
            <Modal disableOutsideClick={true} disableFocusLock= {true} opened={this.state.showFTRDay1Modal} onOpenedChange={(val)=>{if(!val){window.location.href=this.props.addressQualificationDetails?.LTERedirectUrl};this.props.enableCheckAvailabilityButton(true);this.setState({...this.state,showFTRDay1Modal:val})}}>
            <ModalBody>
                <div className="aapagesection" aa-pagesection={ftrDay1header1 + ftrDay1header2} style={{marginBottom:"0.9rem"}}>
                    <h2 style={{color:"#FF0000",display:"inline"}}>{ftrDay1header1}</h2>
                    <h2 style={{display:"inline"}}>{ftrDay1header2}</h2>
                </div>
                <VDS3Body size="large">
                    {ftrDay1Content}
                </VDS3Body>
                <div style={{display:"flex",gap:"1.3rem",marginTop:"1.7rem"}}>
                        <VDS3Button
                            data-track="Yes, I want Frontier"
                            surface="light"
                            disabled={false}
                            use="primary"
                            onClick={() => { 
                                let url = this.props.addressQualificationDetails?.ftrQualification?.FtrRedirectUrl;
                                window.open(url);
                            } }
                        >
                            Yes, I want Frontier
                        </VDS3Button>
                        <VDS3Button
                            data-track="Learn more"
                            surface="light"
                            disabled={false}
                            use="secondary"
                            onClick={() => window.open(FTR_FIOS_URL)}
                        >
                            Learn more
                        </VDS3Button>
                </div>
                {/* <div style={{marginTop:"1rem",textAlign:"center"}}>
                    <Body size="large">Need another option?</Body>
                    Our <TextLink onClick={()=>{
                        let url;
                        if(this.props.addressQualificationDetails?.LTERedirectUrl) url = this.props.addressQualificationDetails?.LTERedirectUrl + `?redirectedFrom=GBCOM&lqsessionId=${this.props.addressQualificationDetails?.GUIEncryptSessionId}`
                        else url = REDIRECT_4G_URL + `?redirectedFrom=GBCOM`
                        window.location.href = url
                    }} className="vds3-optix-expiration-link">4G LTE Internet</TextLink> has you covered.
                </div> */}
            </ModalBody>
        </Modal>
        )
    }
    fiosFTR5G4GPriorityRedirection=()=>{
        let doLoopResp = this.props.addressQualificationDetails;
        let url = '';
        if(doLoopResp?.LQPost?.FiOSDataStatus === "Y"){
            if (doLoopResp?.HasExistingService) {
                this.props.history.push("/ExistingService");
                this.props.setExistingCustomer(true)
            }
            if (doLoopResp?.RedirectToNextPage) {
                    SiteCatalyst.trackQualificationResponse(window.LQRequestBody, window.LQResponse);
                    SiteCatalyst.trackProductsList(window.LQResponse);
                    SiteCatalyst.trackLQAttempts(window.LQRequestBody, { type: 'lq-address-validation', data: window.LQResponse });
                    SiteCatalyst.trackLQSuccess(window.LQRequestBody, { type: 'customize-order', data: window.LQResponse });
                    if (window?.newrelic?.addPageAction) {
                        window.newrelic.addPageAction('LQAttempts', { data: window.LQRequestBody });
                        window.newrelic.addPageAction('LQSuccess', { data: window.LQRequestBody });
                    }
                this.props.history.push({ pathname: "/customize-order", state: { prevPage: 'LQ' } });
            }
        }else if(doLoopResp?.ftrQualification?.FtrQualified === "Y"){
            this.props.triggerFTRMatrix({"LqSessionId":doLoopResp?.GUIEncryptSessionId,"FtrQualified":"Y","RedirectPageShown":"Y","LteRedirected":"N","FtrRedirectd":"Y"})
            this.setState({...this.state,showFTRDay1Modal:true})
            SiteCatalyst.trackLQAttempts(window.LQRequestBody, { type: 'lq-address-validation', data: window.LQResponse });
            SiteCatalyst.trackLQSuccess(window.LQRequestBody, { type: 'customize-order', data: window.LQResponse });
            return;
        }else if(doLoopResp?.Qualified === "true" || doLoopResp?.QualifiedCBand === 'true'){
            if (doLoopResp?.GUIEncryptSessionId) {
                // if(doLoopResp?.FiveGRedirectUrl) url = doLoopResp?.FiveGRedirectUrl + `?redirectedFrom=GBCOM&lqsessionId=${doLoopResp?.GUIEncryptSessionId}${this.props?.cmpCodeForWireless ? `&cmp=${this.props?.cmpCodeForWireless}` : ""}`
                if(doLoopResp?.FiveGRedirectUrl) url = doLoopResp?.FiveGRedirectUrl + `${this.props?.cmpCodeForWireless ? `/${this.props?.cmpCodeForWireless}` : ""}`
                else url = REDIRECT_5G_URL + `${this.props?.cmpCodeForWireless ? `/${this.props?.cmpCodeForWireless}` : ""}`
              } else {
                if(doLoopResp?.FiveGRedirectUrl) url = doLoopResp?.FiveGRedirectUrl + `?redirectedFrom=GBCOM`
                else url = REDIRECT_5G_URL + `?redirectedFrom=GBCOM`
              }
            window.location.href = url
            return;
        }else if(doLoopResp?.Qualified_4g === "true") {
            if(doLoopResp?.LTERedirectUrl) url = doLoopResp?.LTERedirectUrl
            else url = REDIRECT_4G_URL + `?redirectedFrom=GBCOM`
            window.location.href = url
            return;
            }
    }
    CheckAvailability = () => {
        this.props.postUIEventLog({ eventType: 'log', eventName: "CheckAvailability Button Click", sectionName: "LQ", sync:true });
        if (window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction(`Check Availability Button Click`);
        }
        SiteAnalyticsOmni.omniTrackLQAttempts(window.LQRequestBody, { type: 'lq-address-validation', data: window.LQResponse });
        SiteAnalyticsOmni.omniTrackLQSuccess(window.LQRequestBody, { type: 'customize-order', data: window.LQResponse });
        let doLoopResp = this.props.addressQualificationDetails;
        let enableFTROption = false; //(this.props.t && typeof this.props.t == 'function') ? CheckAEMBoolValue(this.props.t("fios.enableFTROption",{ns:"fios"})) : false;
        let FTRDay1Enable = (this.props.t && typeof this.props.t == 'function') ? CheckAEMBoolValue(this.props.t("fios.FTRDay1Enable",{ns:"fios"})) : false;    
        if(FTRDay1Enable && !enableFTROption){
           this.fiosFTR5G4GPriorityRedirection();
        }
        if(enableFTROption && !FTRDay1Enable && doLoopResp?.LQPost?.FiOSDataStatus != "Y" && doLoopResp?.Qualified !== "true" && doLoopResp?.QualifiedCBand !== 'true'){
            if(((this.props?.redirectURL && this.props?.redirectURL?.indexOf("redirectedFrom") > -1) || doLoopResp?.LTERedirectUrl) && doLoopResp?.ftrQualification?.FtrQualified === "Y"){   
                this.props.history.push("/qualification-results");
                return;
            }
        }
        if (this.isValidDetailsSubmitted() && this.state.recaptchaValue!=='' ) {
            this.props.disableCheckAvailabilityButton(true);
            // this.setState({chkAvailibtyClicked:true});
            this.props.setCheckAvailabilityClicked(true);
            if (!this.props.streetAdressInfo?.ntasAddrID && !this.props.streetAdressInfo?.dispstr) {
                const city = this.props.cityAndState ? this.props.cityAndState.split(',')[0]?.trim() : "";
                const state = this.props.cityAndState ? this.props.cityAndState.split(',')[1]?.trim() : "";
                const selectedStreetAddress = {
                    addressID: "",
                    baseAddID: "",
                    baseAddressId: "",
                    city,
                    elkStreet: "",
                    ivappData: null,
                    state,
                    street: this.props.streetValue,
                    unit: this.props.selectedUnit
                };
                this.props.selectedStreetAddress(selectedStreetAddress);
                this.props.triggerAddressQualification();
                this.props.showSpinner(true)
            } else {
                // if(FTRDay1Enable && !enableFTROption){
                //     this.triggerAddressQualificationNew("checkAvailabilytflow");
                //     this.setState({enableSpinner: true});
                // }else{
                this.triggerAddressQualification("checkAvailabilytflow");
                this.setState({enableSpinner: true});
                // }
            }
        } else {
            this.props.enableCheckAvailabilityButton(true);
        }

    }
    triggerAddressQualification = (isChkAvailibtyflow) => {
        let FTRDay1Enable = (this.props.t && typeof this.props.t == 'function') ? CheckAEMBoolValue(this.props.t("fios.FTRDay1Enable",{ns:"fios"})) : false;    
        if(FTRDay1Enable){
            this.triggerAddressQualificationNew(isChkAvailibtyflow);
        }else{
        let optixAddressResponse;
        let enableSpinner = false;
        if (ENABLE_OMNI_CART === "false") {
            optixAddressResponse = null;
        } else {
            optixAddressResponse = this.props.optixAddressQualificationDetails;
        }
        let doLoopResponse = this.props.addressQualificationDetails;
        const cartResponse = this.props.getFloatCartResponse;
        if ((this.props.streetAdressInfo?.ntasAddrID !== this.props.previousAddressID) || this.props.pendingOrderResponseInProgress || (this.props.chkAvailibtyClicked && !doLoopResponse) || !cartResponse || doLoopResponse?.LQPost?.FiOSDataStatus != "Y") {
            enableSpinner = true;
        }
        else {
            doLoopResponse = this.props.addressQualificationDetails;
        }
        if (!doLoopResponse && !this.props.doLoopTriggered) {
            this.props.triggerAddressQualification()
        }
        (!doLoopResponse || !this.props.hasPendingOrderResponse) &&
            (isChkAvailibtyflow === "checkAvailabilytflow" || this.props.chkAvailibtyClicked) && this.props.showSpinner(enableSpinner)
        if (this.props.hasPendingOrderResponse && !this.props.pendingOrderResponseInProgress && doLoopResponse) {
            if (this.props.chkAvailibtyClicked || isChkAvailibtyflow === "checkAvailabilytflow") {
                this.props.setCheckAvailabilityClicked(false);
                this.props.checkAvailAPICall({callback:()=>this.triggerAddressQualification()});
                return;
            }
            console.log("this.props.checkAvailResponse", this.props.checkAvailResponse);
            console.log("optixAddressResponse", optixAddressResponse);
            if (this.props.checkAvailResponse) {
                if (doLoopResponse.LQPost && doLoopResponse.LQPost.S2SLBO == "Y" ) {
                    this.props.redirectLBOPage("S2SLBO");
                }
                else if (doLoopResponse.HasError) {
                    if(doLoopResponse?.Qualified !='true' && doLoopResponse.IDEQualified === 'Y'){
                        this.props.history.push("/internet-services");
                    } else {
                    this.props.showSpinner(true);
                    this.props.redirectionHandler();
                    }
                }
                else if ((doLoopResponse.LQPost && doLoopResponse.LQPost.HSIStatus == "Y" && doLoopResponse.LQPost.FiOSDataStatus != "Y") || (doLoopResponse.IDEQualified === "Y" && doLoopResponse?.LQPost?.FiOSDataStatus !== "Y" && doLoopResponse.Qualified !="true")) {
                   this.props.history.push("/internet-services");
                }
                else if (doLoopResponse.LQPost && doLoopResponse.LQPost.FiOSDataStatus != "Y" && doLoopResponse.LQPost.HSIStatus != "Y") {
                    this.props.showSpinner(true);
                    this.props.redirectionHandler();
                }
                else if (optixAddressResponse?.quoteResultsField?.priceQuotesSetField?.length > 0) {
                    this.props.history.push("/ExistingService");
                    this.props.setExistingCustomer(true)
                }
                else if (doLoopResponse.OOF) {
                    this.props.showSpinner(true);
                    this.props.redirectionHandler();
                }
                else if (doLoopResponse.HasExistingService) {
                    this.props.history.push("/ExistingService");
                   this.props.setExistingCustomer(true)
                }
                else if (doLoopResponse.HasMultipleAddress) {
                    this.props.showSpinner(false)
                    SiteCatalyst.trackQualificationResponse(window.LQRequestBody, window.LQResponse);
                    SiteCatalyst.trackProductsList(window.LQResponse);
                    this.props.setHasMutipleAddress(true)
                }
                else if (this.props.HasPendingOrder) {
                    SiteCatalyst.trackQualificationResponse(window.LQRequestBody, window.LQResponse);
                    SiteCatalyst.trackProductsList(window.LQResponse);
                    this.props.history.push("/pendingOrder");
                    this.props.hasPendingOrder(true)
                    this.props.disableCheckAvailblity(true)
                }
                else if (doLoopResponse.RedirectToNextPage) {
                        SiteCatalyst.trackQualificationResponse(window.LQRequestBody, window.LQResponse);
                        SiteCatalyst.trackProductsList(window.LQResponse);
                        SiteCatalyst.trackLQAttempts(window.LQRequestBody, { type: 'lq-address-validation', data: window.LQResponse });
                        SiteCatalyst.trackLQSuccess(window.LQRequestBody, { type: 'customize-order', data: window.LQResponse });
                        if (window?.newrelic?.addPageAction) {
                            window.newrelic.addPageAction('LQAttempts', { data: window.LQRequestBody });
                            window.newrelic.addPageAction('LQSuccess', { data: window.LQRequestBody });
                        }
                    this.props.history.push({ pathname: "/customize-order", state: { prevPage: 'LQ' } });
                }else{
                    SiteCatalyst.trackQualificationResponse(window.LQRequestBody, window.LQResponse);
                    SiteCatalyst.trackProductsList(window.LQResponse);
                    SiteCatalyst.trackLQAttempts(window.LQRequestBody, { type: 'lq-address-validation', data: window.LQResponse });
                    SiteCatalyst.trackLQSuccess(window.LQRequestBody, { type: 'customize-order', data: window.LQResponse });
                    if (window?.newrelic?.addPageAction) {
                        window.newrelic.addPageAction('LQAttempts', { data: window.LQRequestBody });
                        window.newrelic.addPageAction('LQSuccess', { data: window.LQRequestBody });
                    }
                    this.props.history.push({ pathname: "/customize-order", state: { prevPage: 'LQ' } });
                }
                    try{
                        this.setState({enableSpinner: false});
                    }catch(err) {
                        console.log(err)
                    } 
            }
        }
    }
    }
    triggerAddressQualificationNew = (isChkAvailibtyflow) => {
        // if (this.isValidDetailsSubmitted()) {
        //     const historyObjectForNavigation = this.props.history;
        //     this.props.triggerAddressQualification(historyObjectForNavigation);
        // }
        let optixAddressResponse;
        let enableSpinner = false;
        if (ENABLE_OMNI_CART === "false") {
            optixAddressResponse = null;
        } else {
            optixAddressResponse = this.props.optixAddressQualificationDetails;
        }
        let doLoopResponse = this.props.addressQualificationDetails;
        const cartResponse = this.props.getFloatCartResponse;
        if ((this.props.streetAdressInfo?.ntasAddrID !== this.props.previousAddressID) || this.props.pendingOrderResponseInProgress || (this.props.chkAvailibtyClicked && !doLoopResponse) || !cartResponse || doLoopResponse?.LQPost?.FiOSDataStatus != "Y") {
            enableSpinner = true;
        }
        else {
            doLoopResponse = this.props.addressQualificationDetails;
            //       if(this.props.phoneNumber !== '' && this.isValidDetailsSubmitted()){
            //           // if (doLoopResponse && doLoopResponse.HasExistingService) {
            //                this.props.setExistingCustomer(true); 
            //           // }
            //       }
        }
        if (!doLoopResponse && !this.props.doLoopTriggered) {
            this.props.triggerAddressQualification()
        }
        (!doLoopResponse || !this.props.hasPendingOrderResponse) &&
            (isChkAvailibtyflow === "checkAvailabilytflow" || this.props.chkAvailibtyClicked) && this.props.showSpinner(enableSpinner)
        if (this.props.hasPendingOrderResponse && !this.props.pendingOrderResponseInProgress && doLoopResponse) {
            /* Do not Track LQ Attempts for optix checkout flow*/
            // if(!(optixAddressResponse?.quoteResultsField?.priceQuotesSetField?.length > 0)) {
            //         // SiteCatalyst.trackLQAttempts(window.LQRequestBody, {type: 'lq-address-validation', data: window.LQResponse});
            //     }
            if (this.props.chkAvailibtyClicked || isChkAvailibtyflow === "checkAvailabilytflow") {
                this.props.setCheckAvailabilityClicked(false);
                this.props.checkAvailAPICall({callback:()=>this.triggerAddressQualificationNew()});
                return;
            }
            //Santhosh fix starts here
            // NonDo Call Start Temp fix
            /*const formData = { bannerId: '', fiosPresale: '', fetchProduct: 'ALL' };
            const params = new URLSearchParams();
            const HeadersForFormData = {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
              };
            Object.keys(formData).forEach(key => {
              const value = formData[key];
              params.append(key, value);
            });
            apiClient.post(GET_NONDO_FLOW_URL, params, HeadersForFormData); */
            //Santhosh fix ends here - commented by Bhadri after consulting Pari
            // NonDO Call End
            console.log("this.props.checkAvailResponse", this.props.checkAvailResponse);
            console.log("optixAddressResponse", optixAddressResponse);
            if (this.props.checkAvailResponse) {
                if (doLoopResponse.LQPost && doLoopResponse.LQPost.S2SLBO == "Y" ) {
                    this.props.redirectLBOPage("S2SLBO");
                }
                else if (doLoopResponse.HasError) {
                    // SiteCatalyst.trackQualificationResponse(requestBody, {type: 'out-of-franchise', data: doLoopResponse});
                    // if (!isNightTimeWindow()) {
                    //     SiteCatalyst.trackQualificationResponse(window.LQRequestBody, window.LQResponse);
                    //     SiteCatalyst.trackProductsList(window.LQResponse);
                    //     SiteCatalyst.trackLQAttempts(window.LQRequestBody, { type: 'lq-address-validation', data: window.LQResponse });
                    //     // SiteCatalyst.trackLQFailure(window.LQRequestBody, { type: 'out-of-franchise', data: window.LQResponse });
                    //     if (window?.newrelic?.addPageAction) {
                    //         // window.newrelic.addPageAction('LQAttempts', { data: window.LQRequestBody });
                    //         // window.newrelic.addPageAction('LQFailure', { data: window.LQRequestBody });
                    //     }
                    // }
                    if(doLoopResponse?.Qualified !='true' && doLoopResponse.IDEQualified === 'Y' && doLoopResponse?.ftrQualification?.FtrQualified !== "Y"){
                        this.props.history.push("/internet-services");
                    } else {
                    this.props.showSpinner(true);
                    this.props.redirectionHandler();
                    }
                    // window.scrollTo(0, 0);
                    // this.props.history.push("/out-of-franchise");
                }
                else if ((doLoopResponse.LQPost && doLoopResponse.LQPost.HSIStatus == "Y" && doLoopResponse.LQPost.FiOSDataStatus != "Y") || (doLoopResponse.IDEQualified === "Y" && doLoopResponse?.LQPost?.FiOSDataStatus !== "Y" && doLoopResponse.Qualified !="true"  && doLoopResponse?.ftrQualification?.FtrQualified !== "Y")) {
                   this.props.history.push("/internet-services");
                }
                else if (doLoopResponse.LQPost && doLoopResponse.LQPost.FiOSDataStatus != "Y" && doLoopResponse.LQPost.HSIStatus != "Y" && doLoopResponse?.ftrQualification?.FtrQualified !== "Y") {
                    // if (  !isNightTimeWindow()) {
                    //     SiteCatalyst.trackQualificationResponse(window.LQRequestBody, window.LQResponse);
                    //     SiteCatalyst.trackProductsList(window.LQResponse);
                    //     SiteCatalyst.trackLQAttempts(window.LQRequestBody, { type: 'lq-address-validation', data: window.LQResponse });
                    //     // SiteCatalyst.trackLQFailure(window.LQRequestBody, { type: 'out-of-franchise', data: window.LQResponse });
                    //     if (window?.newrelic?.addPageAction) {
                    //         // window.newrelic.addPageAction('LQAttempts', { data: window.LQRequestBody });
                    //         // window.newrelic.addPageAction('LQFailure', { data: window.LQRequestBody });
                    //     }
                    // }
                    this.props.showSpinner(true);
                    this.props.redirectionHandler();

                    // window.scrollTo(0, 0);
                    // this.props.history.push("/out-of-franchise");
                }
                // else if (this.props?.optixAddressQualificationDetails?.quoteResultsField?.priceQuotesSetField?.length > 0) {
                //     this.props.setExistingCustomer(true)
                // }
                // getVbmaddress call removed fix
                else if (optixAddressResponse?.quoteResultsField?.priceQuotesSetField?.length > 0) {
                    this.props.history.push("/ExistingService");
                    this.props.setExistingCustomer(true)
                }


                else if (doLoopResponse.OOF && doLoopResponse?.ftrQualification?.FtrQualified !== "Y") {
                    //   SiteCatalyst.trackQualificationResponse(requestBody,{type: 'out-of-franchise', data: doLoopResponse});
                    // if (doLoopResponse?.AddressIdPresent !== "Y" && !isNightTimeWindow()) {
                        // SiteCatalyst.trackQualificationResponse(window.LQRequestBody, window.LQResponse);
                        // SiteCatalyst.trackProductsList(window.LQResponse);
                        // SiteCatalyst.trackLQAttempts(window.LQRequestBody, { type: 'lq-address-validation', data: window.LQResponse });
                        // SiteCatalyst.trackLQFailure(window.LQRequestBody, { type: 'out-of-franchise', data: window.LQResponse });
                        // if (window?.newrelic?.addPageAction) {
                            // window.newrelic.addPageAction('LQAttempts', { data: window.LQRequestBody });
                            // window.newrelic.addPageAction('LQFailure', { data: window.LQRequestBody });
                        // }
                    // }
                    this.props.showSpinner(true);
                    this.props.redirectionHandler();
                    // window.scrollTo(0, 0);
                    // this.props.history.push("/out-of-franchise");
                }
                else if (doLoopResponse.HasExistingService) {
                    this.props.history.push("/ExistingService");
                   this.props.setExistingCustomer(true)
                //   window.location.href= "/foryoursmallbiz/gborder/ExistingService?frombroadband=true"
                    // history.push("/customize-order");
                    // yield put({ type: "DISABLE_CHECK_AVAILABILITY" });
                    //  yield put({ type: "IS_EXISTING_CUSTOMER", data: true });
                    //   SiteCatalyst.trackQualificationResponse(requestBody,{type: 'IS_EXISTING_CUSTOMER', data: doLoopResponse});
                }
                //     else if (doLoopResponse.HasExistingService) {
                //         this.props.setExistingCustomer(true)
                //       // history.push("/customize-order");
                //       // yield put({ type: "DISABLE_CHECK_AVAILABILITY" });
                //     //  yield put({ type: "IS_EXISTING_CUSTOMER", data: true });
                //    //   SiteCatalyst.trackQualificationResponse(requestBody,{type: 'IS_EXISTING_CUSTOMER', data: doLoopResponse});
                //     }
                // else if (!doLoopResponse.HasExistingService && optixAddressResponse.HasExistingService){
                //     this.props.setExistingCustomer(true)
                // }
                else if (doLoopResponse.HasMultipleAddress) {
                    this.props.showSpinner(false)
                    SiteCatalyst.trackQualificationResponse(window.LQRequestBody, window.LQResponse);
                    SiteCatalyst.trackProductsList(window.LQResponse);
                    this.props.setHasMutipleAddress(true)
                    /* DISPLAY LIST OF ADDRESSES AVAILABLE in doLoopResponse.AddressList */
                    // yield put({ type: "DISABLE_CHECK_AVAILABILITY" });
                    // yield put({ type: 'HAS_MULTIPLE_ADDRESS', data: true });
                    // SiteCatalyst.trackQualificationResponse(requestBody, {type: 'HAS_MULTIPLE_ADDRESS', data: doLoopResponse});
                }
                else if (this.props.HasPendingOrder && doLoopResponse?.ftrQualification?.FtrQualified !== "Y") {
                    SiteCatalyst.trackQualificationResponse(window.LQRequestBody, window.LQResponse);
                    SiteCatalyst.trackProductsList(window.LQResponse);
                    this.props.history.push("/pendingOrder");
                    // window.location.href= "/foryoursmallbiz/gborder/pendingOrder?frombroadband=true"
                    this.props.hasPendingOrder(true)
                    this.props.disableCheckAvailblity(true)
                    // history.push("/customize-order");
                    //  yield put({ type: "DISABLE_CHECK_AVAILABILITY" });
                    //yield put({ type: 'HAS_PENDING_ORDER', data: true });
                    //  SiteCatalyst.trackQualificationResponse(requestBody,{type: 'HAS_PENDING_ORDER', data: doLoopResponse});
                }
               
                else if (doLoopResponse.RedirectToNextPage && doLoopResponse?.ftrQualification?.FtrQualified !== "Y") {
                    // let selectedUnit = yield select(selectors.selectedUnit);
                    // if (selectedUnit.unit === "I don't live in a unit") {
                    //   yield put({ type: "SAVE_SELECTED_UNIT", data: "" });
                    // }
                    //  SiteCatalyst.trackQualificationResponse(requestBody, {type: 'customize-order', data: doLoopResponse});
                    // if (doLoopResponse?.AddressIdPresent !== "Y" && !isNightTimeWindow()) {
                        SiteCatalyst.trackQualificationResponse(window.LQRequestBody, window.LQResponse);
                        SiteCatalyst.trackProductsList(window.LQResponse);
                        SiteCatalyst.trackLQAttempts(window.LQRequestBody, { type: 'lq-address-validation', data: window.LQResponse });
                        SiteCatalyst.trackLQSuccess(window.LQRequestBody, { type: 'customize-order', data: window.LQResponse });
                        if (window?.newrelic?.addPageAction) {
                            window.newrelic.addPageAction('LQAttempts', { data: window.LQRequestBody });
                            window.newrelic.addPageAction('LQSuccess', { data: window.LQRequestBody });
                        }
                    // }
                    this.props.history.push({ pathname: "/customize-order", state: { prevPage: 'LQ' } });
                    // history.push("/customize-order?SMBBANNERID=BDV~FIOSSIMP+D200000000+U200000000");
                }else if(doLoopResponse?.ftrQualification?.FtrQualified !== "Y"){
                    SiteCatalyst.trackQualificationResponse(window.LQRequestBody, window.LQResponse);
                    SiteCatalyst.trackProductsList(window.LQResponse);
                    SiteCatalyst.trackLQAttempts(window.LQRequestBody, { type: 'lq-address-validation', data: window.LQResponse });
                    SiteCatalyst.trackLQSuccess(window.LQRequestBody, { type: 'customize-order', data: window.LQResponse });
                    if (window?.newrelic?.addPageAction) {
                        window.newrelic.addPageAction('LQAttempts', { data: window.LQRequestBody });
                        window.newrelic.addPageAction('LQSuccess', { data: window.LQRequestBody });
                    }
                    this.props.history.push({ pathname: "/customize-order", state: { prevPage: 'LQ' } });
                }
                if (doLoopResponse.HasPendingOrder) {
                    // yield put({ type: 'HAS_PENDING_ORDER', data: true });
                    //SiteCatalyst.trackQualificationResponse(requestBody, {type: 'HAS_PENDING_ORDER', data: doLoopResponse});
                }
                // setTimeout((() => {
                    try{
                        this.setState({enableSpinner: false});
                    }catch(err) {
                        console.log(err)
                    } 
                // }).bind(this), 5000); 
            }
        }
    }
    validateAllFields=()=>{
        if(this.isValidDetailsSubmitted() && this.state.recaptchaValue!==''){
            
            this.setState({disableCheckAvailability:false})
            const inputContainer = document.getElementById('Email-input');
            if (inputContainer) {
                const inputs = inputContainer.getElementsByTagName("input");
                if (inputs && inputs[0]) {
                    //inputs[0].focus();
                    setTimeout(() => {inputs[0].focus();}, 1000 );
                }
            }
        }
    }

    render() {
        const disbleContinueButton = ()=>{
            let disableButton = false
            if( !!recaptchaRef.current && recaptchaRef.current.getValue() &&
                this.state.recaptchaValue && !this.state.enableErrorMessageForPhoneNumber && 
                !this.state.enableErrorMessageForEmailAddress && !!this.props.emailAddress && 
                String(this.props.emailAddress).length > 0 && !!this.props.phoneNumber && 
                String(this.props.phoneNumber).length > 0) disableButton = false
            return disableButton
        }
        // if(this.props.disableButton) {
        //     return (
        //         <div className="Check-Availability">
        //             <div className="Check-Availability-Button">
        //                 <Button onClick={this.CheckAvailability} disabled={true}>
        //                     Check availability
        //                 </Button>
        //             </div>
        //         </div>
        //     )
        // } 
        return (
            <div>
            {/* <form onSubmit={this.CheckAvailability} > */}
            {this.state.showFTRDay1Modal && this.ftrDay1Modal()}
                <div className="Check-Availability">
                {this.props.disableButton ? <></> : 
                <>
                {this.state.enableSpinner &&  <SpinnerComponent />}
                    <form onSubmit={this.handleSubmit} >
                        <div className="Phone-Input-box">
                            <Input label="Enter phone number*" data-track="lq phone number bar click" pattern= "[0-9]*" inputmode="decimal" value={this.props.phoneNumber || ""} error={this.state.enableErrorMessageForPhoneNumber} errorText={this.state.errorMessageForPhoneNumber}  placeholder="Enter telephone number" name="phone-number" width="100%" onChange={this.savePhoneNumber} success={this.state.enableErrorMessageForPhoneNumber ? false:this.props.phoneNumber?true:false}/>
                        </div>
                    </form>

                    <div className="Promo-Message">
                        {/* <Micro typescale="MVP" primitive="p">Enter a phone number to check availability. If you have a Verizon Business Unlimited Wireless number, you may qualify for a $40 discount when you order Fios Gigabit Connection plan.</Micro> */}
                    </div>

                    {/* <div className="Email-Message">
                        <Body size="large" primitive="p">Enter your email address below in order to save your cart and receive updates on deals and promotions for your business.</Body>
                    </div> */}

                    <form onSubmit={this.handleSubmit}>
                        <div className="Email-Input" id= "Email-input">
                            <Input label={"Enter email address*"}
                                value={this.props.emailAddress || ""}
                                error={this.state.enableErrorMessageForEmailAddress}
                                errorText={this.state.errorMessageForEmailAddress}
                                placeholder={"Enter email address"}
                                name="email-address" width="100%"
                                onChange={this.saveEmailAddress}
                                data-track="lq email address bar click"
                                success={this.state.enableErrorMessageForEmailAddress?false:this.props.emailAddress?true:false}
                                 />
                        </div>
                    </form>
                    </>}
                    <div className={this.props.disableButton ? "hide-captcha" : ""}>
                    <ReCAPTCHA
                        ref={recaptchaRef}
                        // size="invisible"
                        sitekey={GOOGLE_RECAPTCHA_SITEKEY}
                        onChange={(e) => { 
                            console.log(e);
                            const recaptchaValue = recaptchaRef.current.getValue();
                            this.setState({recaptchaValue})
                            console.log(recaptchaValue);
                            this.validateAllFields()
                            
                        }}
                        onExpired={() =>{  this.setState({recaptchaValue: ''})}}
                    />
                    </div>
                    {!this.props.isExistingCustomer ?
                    
                        //  <form onSubmit={this.handleSubmit}>
                        <div className="Check-Availability-Button">
                            <Button type="submit" onClick={this.CheckAvailability}
                            disabled={this.props.disableButton || this.props.enableCheckAvailabilityBtn || (disbleContinueButton())}>
                                Check availability
                        </Button>
                        </div>
                        // </form> 
                        : ''}
                </div>
            {/* </form> */}
            </div>
        );

    }
}


const mapStateToProps = (state) => {
    const { AddressValidationPage, CustomizeOrder } = state
    return {
        enableCheckAvailabilityBtn: AddressValidationPage?.enableCheckAvailabilityBtn ? AddressValidationPage.enableCheckAvailabilityBtn : false,
        previousAddressID: AddressValidationPage?.previousAddressID ? AddressValidationPage.previousAddressID : '',
        addressQualificationDetails: AddressValidationPage?.addressQualificationDetails,
        skipOptixFlowDueToApiFailure: AddressValidationPage?.skipOptixFlowDueToApiFailure,
        doLoopTriggered: AddressValidationPage?.doLoopTriggered,
        chkAvailibtyClicked: AddressValidationPage?.chkAvailibtyClicked,
        HasPendingOrder: AddressValidationPage?.hasPendingOrder,
        hasPendingOrderResponse: AddressValidationPage?.hasPendingOrderResponse,
        pendingOrderResponseInProgress: AddressValidationPage?.pendingOrderResponseInProgress,
        checkAvailResponse: AddressValidationPage?.checkAvailResponse,
        getABLogicResp: AddressValidationPage?.getABLogicResp,
        getFloatCartResponse: CustomizeOrder.getFloatCartResponse,
        customizeProductsResponse: CustomizeOrder.customizeProductsResponse,
        redirectURL: AddressValidationPage?.redirectURL
    };
};

const mapDispatchToProps = (dispatch) => ({
    enableCheckAvailabilityButton: (data) => { dispatch(enableCheckAvailblityButton(data)); },
    disableCheckAvailabilityButton: (data) => { dispatch(disableCheckAvailblityButton(data)); },
    resetCheckoutFlags: (data) => { dispatch(resetCheckoutFlags(data)) },
    setCheckAvailabilityClicked: (data) => { dispatch(setCheckAvailabilityClicked(data)) },
    redirectionHandler: (data) => { dispatch(redirectionHandler(data)) },
    redirectLBOPage: (data) => { dispatch(redirectLBOPage(data)) },
    triggerFTRMatrix: (data) => { dispatch(triggerFTRMatrix(data)) },
});
CheckAvailability = connect(mapStateToProps, mapDispatchToProps)(CheckAvailability);
export default CheckAvailability;